<!--
Author: TangChen
Date: 2018-12-07
Desc: 适当性协议内容
-->
<template>
    <div class="comp-fund-protocol comp">
        <!--<el-checkbox name="type">
            <i>基金有风险，投资需谨慎，请查看</i><span v-for="item of protocol" :key="item.id" v-on:click.prevent="agreementCon(item)">《{{ item.title }}》</span>
        </el-checkbox>-->
        <el-dialog
            :title="protocolTitle"
            :visible.sync="centerDialogVisible"
            width="36%"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            v-on:close="close"
        >
            <div class="protocol-con">
                <i class="el-icon-warning" aria-hidden="true" />
                <div class="protocol-msg" v-html="protocolHtml" />
            </div>
            <div slot="footer" class="dialog-footer align-c">
                <el-button type="primary" v-on:click="confirmCon">确认并继续</el-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="agrCon.title"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            v-on:close="close"
        >
            <div v-if="agrCon.content" v-html="agrCon.content" />
            <div
                v-else-if="filePath"
                v-loading="fileLoading"
                style="justify-content: center; display: flex"
            >
                <iframe
                    ref="iframe"
                    style="width: 800px; height: 400px; border: none"
                    :src="filePath"
                    v-on:load="onLoad"
                ></iframe>
                <!--                <iframe
                    ref="iframe"
                    style="width: 600px; height: 400px"
                    :src="fileUrl + '#toolbar=0'"
                    :toolbar="false"
                ></iframe>-->
            </div>
            <div slot="footer" class="dialog-footer align-c">
                <el-button type="primary" v-on:click="confirmCon">确认并继续</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import fundApi from "@/api/fund";
const fileUrl = "/js/pdfjs/web/viewer.html";
export default {
    name: "FundProtocol",
    props: {
        fund: {
            type: Object,
            required: true
        },
        value: {
            type: Boolean,
            default: false
        },
        showProtoArr: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            agrCon: {},
            protocol: [],
            centerDialogVisible: false,
            dialogVisible: false,
            protocolTitle: "",
            protocolHtml: "",
            info: {},
            index: 0,
            publicPath: process.env.BASE_URL,
            fileUrl: "",
            filePath: "",
            fileLoading: false
        };
    },
    watch: {
        value(val) {
            if (val) {
                if (this.protocol.length === this.index && this.index > 0) {
                    this.$emit("all-read", true);
                    return;
                }
                this.fundPopMes();
            }
        }
    },
    mounted() {
        this.info = this.$cache.getUser();
    },
    methods: {
        handlePdfUrlChange(val) {
            if (val) {
                this.fileLoading = true;
                const fileGet = this.$util.fileDownloadPath(val);
                this.filePath =
                    fileUrl + "?file=" + encodeURIComponent(fileGet) + "#page=1&#toolbar=0";
            }
        },
        onLoad() {
            const iframe = this.$refs.iframe;
            this.$nextTick(() => {
                iframe.contentWindow.PDFViewerApplication.appConfig.toolbar.container.classList.add(
                    "hidden"
                );
                this.fileLoading = false;
            });
        },
        close() {
            this.centerDialogVisible = false;
            this.dialogVisible = false;
            this.$emit("all-read", false);
            this.filePath = "";
        },
        base64ToBlob(base64, contentType) {
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            return new Blob([byteArray], { type: contentType });
        },
        getPdfBase64(item) {
            if (item.fileid) {
                this.fileUrl = "";
            }
            const _this = this;
            let params = {
                fileCode: item.fileid
            };
            // 转base64方法太慢了
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async (resolve, reject) => {
                const res = await fundApi.getPdfBase64(params);
                if (res.data) {
                    const pdfBlob = this.base64ToBlob(res.data, "application/pdf");
                    const pdfUrl = URL.createObjectURL(pdfBlob);
                    _this.fileUrl = pdfUrl;
                    resolve();
                }
            });
        },
        agreementCon(val) {
            let _this = this;
            this.protocolTitle = val.title;
            let _html = "";
            let _type = "";
            if (val.id < 4) {
                this.agreementText(val);
                return;
            }
            // upm协议内容
            if (val.ump) {
                _this.agrCon = val;
                // _this.dialogVisible = true;
                this.handlePdfUrlChange(val.fileid);
                // this.getPdfBase64(_this.agrCon);
                this.$nextTick(() => {
                    _this.dialogVisible = true;
                });
                // this.$util.request("common/protocol/content", val).then(res => {
                //     if (res.data) {
                //         const con = res.data[0];
                //         if (con) {
                //             _this.agrCon = con;
                //             _this.dialogVisible = true;
                //         }
                //     }
                // });
            } else {
                // 适当性协议内容
                if (val.id === "4") {
                    _html = this.getMatchMsg();
                    _type = "0";
                } else if (val.id === "5") {
                    _html = this.riskWarning();
                } else if (val.id === "6") {
                    _type = "1";
                    _html = this.riskMismatch();
                } else if (val.id === "7") {
                    _type = "2";
                    _html =
                        '您正在购买的产品属于<span class="red">高风险</span>产品，请确认已经仔细阅读产品合同等法律文件以了解产品风险。';
                }
                this.protocolHtml = _html;
                if (_type !== "") {
                    this.$util.getProtocol(_type, this.fund.fundshowtype).then((res) => {
                        if (res.length && res[0].content) {
                            _this.protocolHtml += "<div>" + res[0].content + "</div>";
                        }
                        _this.centerDialogVisible = true;
                    });
                    return;
                }
                this.centerDialogVisible = true;
            }
        },
        confirmCon() {
            this.centerDialogVisible = false;
            this.dialogVisible = false;
            this.index++;
            if (this.index === this.protocol.length) {
                this.$emit("all-read", true);
                return;
            }
            setTimeout(() => {
                this.autoShow();
            }, 1000);
        },
        autoShow() {
            if (this.protocol.length === 0) {
                return this.$emit("all-read", true);
            }
            this.agreementCon(this.protocol[this.index]);
        },
        // 查询具体合同内容
        agreementText(val) {
            let _this = this;
            const _data = {
                fundcode: this.fund.fundcode,
                tano: this.fund.tano,
                type: val.id,
                maintextno: this.fund.maintextno
            };
            this.$util.request("pef/trade/contract", _data).then((res) => {
                if (res.data) {
                    const con = res.data[0];
                    if (con) {
                        con.title = val.title;
                        _this.agrCon = con;
                        this.handlePdfUrlChange(con.fileid);
                        // this.getPdfBase64(_this.agrCon);
                        this.$nextTick(() => {
                            _this.dialogVisible = true;
                        });
                    }
                }
            });
        },
        // 获取投资品种文字
        getKind(val) {
            if (val && val.trim() !== "") {
                const _arrKind = val.split(",");
                let _kindTextArr = [];
                _arrKind.forEach((arr) => {
                    _kindTextArr.push(this.$cache.getDict("150072", arr));
                });
                return _kindTextArr.join("/");
            }
            return val;
        },
        // 获取适当性提示信息类型
        fundPopMes() {
            this.protocol = [];
            if (this.fund.needsignelecpaper === "1") {
                // 电子合同名称
                if (this.fund.contracttitle.trim() !== "") {
                    this.protocol.push({ id: "1", title: this.fund.contracttitle });
                }
                // 电子签名约定书名称
                if (this.fund.elecsigntitle.trim() !== "") {
                    this.protocol.push({ id: "3", title: this.fund.elecsigntitle });
                }
                // 风险揭示书名称
                if (this.fund.riskannouncetitle.trim() !== "") {
                    this.protocol.push({ id: "0", title: this.fund.riskannouncetitle });
                }
            }
            // ump添加协议获取
            if (this.fund.protoArr && this.fund.protoArr.length > 0 && this.showProtoArr) {
                const _x = this.fund.protoArr;
                for (let pro of _x) {
                    pro.ump = true;
                    this.protocol.push(pro);
                }
            }
            // 放到单独的适当性提示框组件中完成
            // if (this.fund.fundmismatchflag === "1") {
            //     this.protocol.push({ id: "4", title: "投资品种/期限不匹配提示" });
            // }
            // if (this.fund.riskmismatchflag === "1") {
            //     this.protocol.push({ id: "6", title: "风险不匹配警示函" });
            // }

            /* if (this.fund.riskwarnflag === "1") {//modify by zhengdongzhou 客户要求只需不匹配提示，普通投资者、专业过期不需要风险揭示书
                this.protocol.push({id: "5", title: "风险提示书"});
            } */

            // 放到单独的适当性提示框组件中完成
            // if (this.fund.highriskwarnflag === "1") {
            //     this.protocol.push({ id: "7", title: "高风险提示" });
            // }
            this.autoShow();
        },
        riskMismatch() {
            return (
                "尊敬的投资者<br />" +
                "<div style='text-align: justify'>&emsp;&emsp;您申请购买的产品风险等级为（<span class=\"red\">" +
                this.$cache.getDict("110143", this.fund.risklevel) +
                '</span>），您当前风险等级为（<span class="red">' +
                this.$cache.getDict("100017", this.info.risklevel) +
                "）</span>" +
                "，根据适当性匹配原则，该产品高于您风险承受能力，购买该产品，可能导致您承担超出自身承受能力损失以及不利后果。请您认真考虑相应风险，审慎决定购买该产品。请确认已阅读《风险不匹配警示函》，经审慎考虑，您仍坚持申请购买该产品，并自愿承担由此可能产生的一切不利后果和损失。" +
                this.$cache.getCompanyInfoParam("10101001") +
                "工作人员从未主动向您推介该产品。</div>"
            );
        },
        riskWarning() {
            return "&emsp;&emsp;本人已收到贵司出具的《风险不匹配警示函》，对于本人申请购买产品/服务风险等级高于本人风险承受能力情况已知悉，并且已充分了解该产品/服务的风险特征和可能的不利后果。<br />&emsp;&emsp;经本人审慎考虑，仍坚持申请购买该产品/服务，并自愿承担由此可能产生的一切不利后果和损失。<br />&emsp;&emsp;该销售机构及工作人员在销售过程中，不存在直接或间接主动向本人推介该产品/服务的行为。";
        },
        // 绘制投资期限/品种不匹配提示信息弹框
        getMatchMsg() {
            const fund = this.fund;
            if (fund.fundmismatchflag === "1") {
                let _matchFlagText = "";
                const userInvestTerm = this.$cache.getDict("150071", fund.userinvestterm);
                const userInvestKind = this.getKind(fund.userinvesttype);
                const fundInvestTerm = this.$cache.getDict("150071", fund.investterm);
                const fundInvestKind = this.getKind(fund.investkind);
                if (fund.typemismatchflag === "1" && fund.termmismatchflag === "1") {
                    _matchFlagText =
                        '您的投资品种为<span class="red">' +
                        userInvestKind +
                        '</span>，投资期限为<span class="red">' +
                        userInvestTerm +
                        '</span>，所购买产品的投资品种为<span class="red">' +
                        fundInvestKind +
                        '</span>，投资期限为<span class="red">' +
                        fundInvestTerm +
                        "</span>。";
                } else if (fund.termmismatchflag === "1") {
                    // 投资期限
                    _matchFlagText =
                        '您的投资期限为<span class="red">' +
                        userInvestTerm +
                        '</span>，所购买产品的投资期限为<span class="red">' +
                        fundInvestTerm +
                        "</span>。";
                } else if (fund.typemismatchflag === "1") {
                    // 投资品种
                    _matchFlagText =
                        '您的投资品种为<span class="red">' +
                        userInvestKind +
                        '</span>，所购买产品的投资品种为<span class="red">' +
                        fundInvestKind +
                        "</span>。";
                }
                return _matchFlagText;
            }
            return false;
        }
    }
};
</script>
<style lang="scss">
.comp-fund-protocol {
    max-width: 800px;
    line-height: 20px;
    display: inline-block;

    .el-dialog__body {
        padding: 10px 20px;
    }

    .el-dialog {
        .el-dialog__header {
            line-height: 30px;

            .el-icon-close:before {
                color: var(--color-primary);
                font-size: $f20;
            }
        }
    }

    .el-dialog__body {
        .protocol-con {
            line-height: 24px;
            position: relative;
            padding-left: 30px;

            .el-icon-warning {
                font-size: $f24;
                color: var(--color-primary);
                position: absolute;
                top: 0;
                left: 0;
            }

            .red {
                color: $color-c;
            }

            .k-risk-alert {
                p {
                    display: inline-block;
                }
            }
        }
    }

    .el-checkbox__input {
        vertical-align: top;
    }

    .el-checkbox__label {
        line-height: 20px;
        color: $text-color1;
        cursor: default;

        &:after {
            content: "";
            clear: both;
            overflow: hidden;
            display: block;
            height: 0;
        }

        i {
            font-style: normal;
            float: left;
        }

        span {
            color: $color-b;
            cursor: pointer;
            display: inline-block;
            float: left;

            &:after {
                content: "、";
                color: $text-color1;
            }

            &:last-child:after {
                content: "";
            }

            &:hover {
                color: var(--color-primary);
            }
        }
    }
}
</style>
